import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const customRoutes = [
  { method: "GET", path: "/dashboard", handlerName: "getDashboard" },
  { method: "GET", path: "/notifications/:id/replies", handlerName: "getNotificationReplies" },
  { method: "POST", path: "/notifications/:id/check-replies", handlerName: "checkNotificationReplies" },
  { method: "POST", path: "/notifications/:id/reply", handlerName: "sendReply" },
  { method: "PUT", path: "/notifications/:id/complete", handlerName: "markAsCompleted" },
  { method: "GET", path: "/monitor/status", handlerName: "getMonitorStatus" },
  { method: "POST", path: "/monitor/start", handlerName: "startMonitoring" },
  { method: "POST", path: "/monitor/stop", handlerName: "stopMonitoring" },
  { method: "GET", path: "/gmail/auth-url", handlerName: "getGmailAuthUrl" },
];

export const emailRepliesService = createCrudService("emailReplies", customRoutes, router);

const api = new CommonAPIService(router);
emailRepliesService.downloadAttachment = (notificationId, replyId, attachmentId) => {
  return api.getBlobCall(`/api/emailReplies/notifications/${notificationId}/replies/${replyId}/attachments/${attachmentId}`);
};
